<template>
  <div class="edit-sorting d-flex flex-column gap-2">
    <b-form-select
      v-model="addField"
      :options="addableFields"
      size="sm"
      @change="onAddField"
    ></b-form-select>

    <draggable
      tag="div"
      :list="sortFields"
      class="d-flex flex-column flex-wrap gap-2"
      handle=".drag-handle"
      @change="updateSortOrder()"
    >
      <div
          v-for="field in sortFields"
          :key="field.uuid"
          class="d-flex gap-2 align-items-center"
      >
          <div class="drag-handle">
            <i class="fas fa-arrows-alt"></i>
          </div>
          <div>#{{ field.sort_index | format }}</div>
          <div class="w-100">
            <span v-if="field.field_name.length === 0">New field</span>
            <span v-else>{{ field.field_name }}</span>
          </div>
          <div>
            <button-select
              v-model="field.sort_direction"
              :options="options.sort_direction"
            ></button-select>
          </div>
          <div>
            <b-btn variant="danger" size="sm" @click="removeField(field)">
              <i class="fas fa-trash"></i>
            </b-btn>
          </div>
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

const ButtonSelect = () => import('@/components/global/ButtonSelect.vue');

export default {
  name: 'EditSorting',
  components: {
    draggable,
    ButtonSelect,
  },
  props: {
    value: Array,
  },
  computed: {
    addableFields() {
      return this.value
        .filter((field) => field.sort_index === null && field.is_exported === true)
        .map((field) => ({
          text: field.field_name,
          value: field.uuid,
        }));
    },
  },
  data() {
    return {
      addField: null,
      sortFields: [],
      options: {
        sort_direction: [
          { text: 'Asc', value: 'asc' },
          { text: 'Desc', value: 'desc' },
        ],
      },
    };
  },
  methods: {
    buildSortFields() {
      this.sortFields = this.value
        .filter((field) => field.sort_index !== null)
        .sort((a, b) => a.sort_index - b.sort_index);
    },
    onAddField(uuid) {
      const field = this.value.find((f) => f.uuid === uuid);
      if (field) {
        field.sort_index = this.sortFields.length + 1;
        this.sortFields.push(field);
      }
      this.addField = null;
    },
    updateSortOrder() {
      this.sortFields.forEach((field, index) => {
        field.sort_index = index + 1;
      });
    },
    removeField(field) {
      field.sort_index = null;
      this.sortFields = this.sortFields.filter((f) => f.uuid !== field.uuid);
      this.updateSortOrder();
    },
  },
  created() {
    this.buildSortFields();
  },
};
</script>

<style lang="scss" scoped>
    .edit-sorting {
        max-width: 400px;
    }
</style>
